export type ContasReceberPeriodoVencimentoPreset =
  | "hoje"
  | "7d"
  | "30d"
  | "mes"
  | "personalizado";

/** Formato `yyyy-MM-dd` em calendário local. */
export function formatarYmdLocal(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function inicioFimMesCorrenteLocal(): { vencimentoInicio: string; vencimentoFim: string } {
  const now = new Date();
  const ini = new Date(now.getFullYear(), now.getMonth(), 1);
  const fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return {
    vencimentoInicio: formatarYmdLocal(ini),
    vencimentoFim: formatarYmdLocal(fim),
  };
}

export function periodoVencimentoParaDatas(
  preset: ContasReceberPeriodoVencimentoPreset,
): { vencimentoInicio: string; vencimentoFim: string } | null {
  const hoje = new Date();
  const ymd = formatarYmdLocal;

  switch (preset) {
    case "hoje": {
      const d = ymd(hoje);
      return { vencimentoInicio: d, vencimentoFim: d };
    }
    case "7d": {
      const fim = new Date(hoje);
      fim.setDate(fim.getDate() + 7);
      return { vencimentoInicio: ymd(hoje), vencimentoFim: ymd(fim) };
    }
    case "30d": {
      const fim = new Date(hoje);
      fim.setDate(fim.getDate() + 30);
      return { vencimentoInicio: ymd(hoje), vencimentoFim: ymd(fim) };
    }
    case "mes":
      return inicioFimMesCorrenteLocal();
    default:
      return null;
  }
}
